import { render } from "./ProcessManagement.vue?vue&type=template&id=6e7eb2f8"
import script from "./ProcessManagement.vue?vue&type=script&lang=js"
export * from "./ProcessManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__